// extracted by mini-css-extract-plugin
module.exports = {"color-mischka":"#e0e1e7","colorMischka":"#e0e1e7","color-storm-grey":"#6D7288","colorStormGrey":"#6D7288","button":"B3BXv #6D7288"};